<template>
  <div class="wrap">
    <iframe src="http://promotion.mashangchayao.com/#/login" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  name: 'show-page'
}
</script>
<style lang="stylus" scoped>
.wrap {
    width 100%
    height 100%
    iframe {
      width 100%
      height 100%
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/show-page/index.vue